import _ from 'lodash';
import axios from 'axios';
import dayjs from 'dayjs';
// import dayjs from 'dayjs';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';
import { StyledBox, StyledBoxHeader, StyledBoxLabel } from '../../../CSS/style';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { API_DEVICE, API_INSPECTIONCONFIG } from '../../../../../commons/api';
import { Form, message, Select, DatePicker, Input, TimePicker, Modal, Button, Typography } from 'antd';
import {
  getDeviceList,
  getSitesList,
  getUsersList,
  getLocationByAsset,
  submitScheduleInspection,
  getJobPlanById,
  getMasterList,
  getStatusListPM,
  getscheduleInspectByID,
  getWorkTypesEInspec,
  getFrequency,
  getJobPlansListByEquipment
} from '../../../Utils/FormCalls';

const { Option } = Select;
const urlList = {
  list: API_INSPECTIONCONFIG.GET
};

const PMDetails = (props) => {
  const [tableData, setTableData] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [JobPlansList, setJobPlansList] = useState([]);
  // const [InspectionData, setInspectionData] = useState([]);
  const [frequencyObject, setFrequencyObject] = useState({});
  const [days, setDays] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [, setInspectionMasterList] = useState([]);
  const [, setJobPlanName] = useState('');
  const [searchText, setSearchText] = useState('');
  const formHeader = useRef();
  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      let value = 0;
      let daysArray = [];
      for (let i = value + 1; i <= 31; i++) {
        daysArray.push(i);
      }
      handleChange(dayjs().add(1, 'days'), 'EffectiveStartDate');
      setDays(daysArray);
      let inspectionMasterListData = await getMasterList(urlList.list);
      setInspectionMasterList(inspectionMasterListData);

      let sitesListData = await getSitesList();
      let formObjectData = formHeader.current.getFieldsValue();
      formObjectData = {
        ...formObjectData,
        SiteId: sitesListData && sitesListData[0] && sitesListData[0].Id ? sitesListData[0].Id : ''
      };
      formHeader.current.setFieldsValue(formObjectData);
      setSitesList(sitesListData);
      setFormObject(formObjectData);

      try {
        let deviceListData = await getDeviceList();
        setDeviceList(deviceListData);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        let usersListData = await getUsersList();
        setUsersList(usersListData);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      let workTypes = await getWorkTypesEInspec('PM');
      setWorkTypesList(workTypes);

      try {
        let statusData = await getStatusListPM();
        setStatusList(statusData);
        if (formObjectData && !formObjectData.Id) {
          handleChange(
            statusData && statusData[0] && statusData[0]['Value'] ? statusData[0]['Value'] : null,
            'StatusId'
          );
        }
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        let frequencyListData = await getFrequency();
        let frequencyObjectData = {};
        frequencyListData &&
          Array.isArray(frequencyListData) &&
          frequencyListData.map((freq) => {
            frequencyObjectData[freq.Key] = freq.Value;
            return {};
          });
        setFrequencyList(frequencyListData);
        setFrequencyObject(frequencyObjectData);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  const _getDataById = async (Id) => {
    let formObjectData = {};
    let path = props.location.pathname.split('/rubus/AMM/PreventiveMaintenanceDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getscheduleInspectByID(formId);
      _.cloneDeepWith(data, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['CreatedDate'] = value.CreatedDate
              ? dayjs.utc(value.CreatedDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['EffectiveStartDate'] = value.EffectiveStartDate
              ? dayjs.utc(value.EffectiveStartDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['EffectiveEndDate'] = value.EffectiveEndDate
              ? dayjs.utc(value.EffectiveEndDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['CreationTime'] = value.CreationTime
              ? dayjs.utc(value.CreationTime, 'YYYY-MM-DD HH:mm:ss').local()
              : null)
          }
          : _.noop();
      });
      formObjectData = {
        ...data,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      getJobPlanList(data.Equipment);
      let inspectionMasterListData = await getMasterList(urlList.list);
      formHeader.current && formHeader.current.setFieldsValue(formObjectData);
      setFormObject(formObjectData);
      setInspectionMasterList(inspectionMasterListData);
    } else if (Id) {
      let data = await getscheduleInspectByID(Id);
      _.cloneDeepWith(data, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['CreatedDate'] = value.CreatedDate
              ? dayjs.utc(value.CreatedDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['EffectiveStartDate'] = value.EffectiveStartDate
              ? dayjs.utc(value.EffectiveStartDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['EffectiveEndDate'] = value.EffectiveEndDate
              ? dayjs.utc(value.EffectiveEndDate, 'YYYY-MM-DD HH:mm:ss').local()
              : null),
            ...(value['CreationTime'] = value.CreationTime
              ? dayjs.utc(value.CreationTime, 'YYYY-MM-DD HH:mm:ss').local()
              : null)
          }
          : _.noop();
      });
      formObjectData = {
        ...data,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };

      getJobPlanList(data.Equipment);
      let inspectionMasterListData = await getMasterList(data.list);
      formHeader.current && formHeader.current.setFieldsValue(formObjectData);
      setFormObject(formObjectData);
      setInspectionMasterList(inspectionMasterListData);
    }
  };

  const handleChange = async (value, key) => {
    let formObjectData = formHeader.current && formHeader.current.getFieldsValue();
    if (key === 'Equipment') {
      let selectedDevice = deviceList.filter((item) => item.AliasCode === value);
      let location = await getLocationByAsset(selectedDevice[0] && selectedDevice[0].Asset);

      formObjectData = {
        ...formObjectData,
        [key]: value,
        EquipmentDescription: selectedDevice[0].AliasCode,
        Location: location.AssetCode,
        AssetDisplayCode: location.AssetDisplayCode,
        LocationDescription: location.Name
      };
      formHeader.current.setFieldsValue(formObjectData);
      setFormObject(formObjectData);
    }
    if (key === 'CreatedBy') {
      let selectedUser = usersList.filter((item) => item.Id === value);
      formObjectData = {
        ...formObjectData,
        [key]: value,
        Name: selectedUser[0]['User Name'],
        Phone: selectedUser[0]['MobileNumber'],
        Email: selectedUser[0]['Email']
      };
    } else if (
      key === 'TargetStart' ||
      key === 'TargetFinish' ||
      key === 'ActualStart' ||
      key === 'ActualFinish' ||
      key === 'RecordDate'
    ) {
      formObjectData = {
        ...formObjectData,
        [key]: dayjs(value).format('YYYY-MM-DD')
      };
    } else if (key === 'WorkTypeId') {
      formObjectData = {
        ...formObjectData,
        FrequencyId: '',
        Days: [],
        [key]: value
      };
    } else if (key === 'CreationTime') {
      formObjectData = {
        ...formObjectData,
        [key]: dayjs(value, 'HH:mm')
      };
    } else {
      formObjectData = {
        ...formObjectData,
        [key]: value
      };
    }
    formHeader.current && formHeader.current.setFieldsValue(formObjectData);
    setFormObject(formObjectData);
  };

  const onFinish = async (values) => {
    let userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    let creationTime = dayjs(values.CreationTime).format('HH:mm:ss');
    let startDate = dayjs(values.EffectiveStartDate).format(`YYYY-MM-DD ${creationTime}`);
    let endDate = dayjs(values.EffectiveEndDate).format(`YYYY-MM-DD ${creationTime}`);
    let payload = {
      ...formObject,
      ...values,
      CreationTime: values.CreationTime
        ? dayjs.utc(values.CreationTime).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      EffectiveStartDate: values.EffectiveStartDate
        ? dayjs(startDate).utc().format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      EffectiveEndDate: values.EffectiveEndDate
        ? dayjs(endDate).utc().format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
      ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
    };
    let statusResponse = await submitScheduleInspection(payload);
    if (statusResponse && statusResponse.message) {
      message.success(statusResponse.message);
      props.navigate('/rubus/AMM/PMList');
      _getDataById(statusResponse.Id);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  // const createWorkOrder = async () => {
  //   message.warning('Development in progress');
  // };

  const getJobPlanList = async (Equipment) => {
    let JobPlansListData = await getJobPlansListByEquipment('Active', Equipment);
    setJobPlansList(JobPlansListData);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getDeviceData = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const { data } = await axios(headers);

      setTableData(data);
      setFormObject(formHeader.current.getFieldsValue());
      // Assuming you have a way to manage the state of the key
      setVisible(true); // Implement this function based on your modal state management
    } catch (error) {
      console.error('Error fetching device data:', error);
    }
  };

  const jobPlanOnChange = async (value) => {
    try {
      const jobplanData = await getJobPlanById(value, 'withoutId');
      let currentFormObject = formHeader.current.getFieldValue();

      currentFormObject = {
        ...currentFormObject,
        JobPlanDescription: jobplanData?.JobPlanDescription || ''
      };

      formHeader.current.setFieldsValue(currentFormObject);
      setFormObject({
        ...currentFormObject,
        JobPlan: jobplanData,
        JobPlanDescription: jobplanData.JobPlanDescription
      });
      setJobPlanName(value);
    } catch (error) {
      console.error('Error fetching job plan data:', error);
    }
  };

  const tableDropdownChange = async (value) => {
    let currentFormObject = formHeader.current.getFieldsValue();
    let selectedDevice = deviceList.filter((item) => item.AliasCode === value.AliasCode);
    let location = await getLocationByAsset(selectedDevice[0]?.Asset);

    currentFormObject = {
      ...currentFormObject,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      Location: location?.[0]?.AssetCode,
      AssetDisplayCode: location[0].DisplayCode,
      LocationDescription: location?.[0]?.Name
    };

    formHeader.current.setFieldsValue(currentFormObject);
    setFormObject(currentFormObject);
    setVisible(false);
    getJobPlanList(value.AliasCode);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput.current = node;
          }}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}>
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const filterWorkType =
    workTypesList &&
    Array.isArray(workTypesList) &&
    workTypesList.filter((item) => {
      const workTypeId = formHeader.current.getFieldValue('WorkTypeId');
      return workTypeId !== undefined && item.Value === workTypeId;
    });
  return (
    <>
      <Form
        name="SR"
        ref={formHeader}
        onFinish={onFinish}
        initialValues={formObject}
        layout="vertical"
      >
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button
            type="primary"
            style={{ marginLeft: '5px' }}
            htmlType="submit">
            {translation(props.translationCache, constant.submit)}
          </Button>
        </div>
        <StyledBoxHeader>
          <StyledBox>
            <Form.Item
              label={translation(props.translationCache, constant.Name)}
              name="Name"
              rules={[
                { required: true, message: translation(props.translationCache, 'Input Name!') }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Name')}
                value={formObject.Name}
                onChange={(e) => handleChange(e, 'Name')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.description)}
              name="Description"
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Input Description!')
                }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Input Description')}
                onChange={(e) => handleChange(e, 'Description')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.workType)}
              name="WorkTypeId"
              rules={[
                { required: true, message: translation(props.translationCache, 'Select Work Type') }
              ]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Work Type')}
                onChange={(value) => handleChange(value, 'WorkTypeId')}
                disabled={formObject && formObject.Id ? true : false}
                style={{ width: '100%' }}>
                {workTypesList &&
                  Array.isArray(workTypesList) &&
                  workTypesList.map((workType, index) => {
                    return (
                      <Option key={index} value={workType.Value}>
                        {translation(props.translationCache, workType.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true, message: 'Select Site' }]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Site')}
                onChange={(value) => handleChange(value, 'SiteId')}
                style={{ width: '100%' }}
                disabled>
                {sitesList &&
                  Array.isArray(sitesList) &&
                  sitesList.map((site, index) => {
                    return (
                      <Option key={index} value={site.Id}>
                        {site.Name}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true, message: 'Select Equipment' }]}>
              <Input
                disabled={true}
                style={{
                  width: '100%'
                }}
                placeholder={translation(props.translationCache, 'Select Equipment')}
                suffix={
                  <DownOutlined
                    style={{
                      color: formObject && formObject.Id ? null : '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  />
                }
              />
            </Form.Item>

            <Form.Item
              label={translation(props.translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                disabled
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.Location)}
              name="AssetDisplayCode"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.locationDescription)}
              name="LocationDescription"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
                disabled={true}
              />
            </Form.Item>

            <Form.Item
              label={translation(props.translationCache, constant.createdBy)}
              name="CreatedBy"
              rules={[{ required: false, message: 'Select Created By' }]}>
              <Select
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created By')}
                onChange={(value) => handleChange(value, 'CreatedBy')}>
                {usersList &&
                  Array.isArray(usersList) &&
                  usersList.map((user, index) => {
                    return (
                      <Option key={index} value={user.Id}>
                        {user.FirstName}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.CreatedDate)}
              name="CreatedDate"
              rules={[{ required: false, message: 'Created Date' }]}>
              <DatePicker
                format={'YYYY-MM-DD HH:mm:ss'}
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created Date')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.status)}
              name="StatusId"
              rules={[{ required: true, message: 'Please Select Status' }]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Status')}
                onChange={(value) => handleChange(value, 'StatusId')}
                style={{ width: '100%' }}>
                {statusList &&
                  Array.isArray(statusList) &&
                  statusList.map((status, index) => {
                    return (
                      <Option key={index} value={status.Value}>
                        {translation(props.translationCache, status.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item name="Equipment"></Form.Item>


          </StyledBox>
        </StyledBoxHeader>

        <>
          <StyledBoxHeader>
            <StyledBoxLabel>
              <Typography.Title level={5}>
                {filterWorkType && filterWorkType[0] && filterWorkType[0]['WorkType']
                  ? filterWorkType[0]['WorkType']
                  : null}</Typography.Title>
            </StyledBoxLabel>

            <StyledBox>
              <Form.Item
                label={translation(props.translationCache, constant.jobPlan)}
                name="JobPlanId"
                rules={[{ required: true }]}>
                <Select
                  style={{ width: '100%' }}
                  placeholder={translation(props.translationCache, 'Select JobPlan')}
                  onChange={(value) => jobPlanOnChange(value)}>
                  {JobPlansList &&
                    Array.isArray(JobPlansList) &&
                    JobPlansList.map((jobplan, index) => {
                      return (
                        <Option key={index} value={jobplan.Id}>
                          {jobplan.JobPlanName}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation(props.translationCache, constant.jobplanDescription)}
                name="JobPlanDescription">
                <InputComponent
                  style={{ width: '100%' }}
                  placeholder={translation(props.translationCache, 'Enter JobPlanDescription')}
                />
              </Form.Item>
            </StyledBox>
          </StyledBoxHeader>

          {formHeader.current &&
            formHeader.current.getFieldValue('JobPlanId') &&
            formHeader.current.getFieldValue('JobPlanId') !== undefined ? (
            <StyledBoxHeader >
              <StyledBoxLabel>{translation(props.translationCache, 'Schedule')}</StyledBoxLabel>
<StyledBox>
              <Form.Item
                label={translation(props.translationCache, constant.effectiveStartDate)}
                name="EffectiveStartDate">
                <DatePicker
                  inputReadOnly={true}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  onChange={(value) => {
                    handleChange(value, 'EffectiveStartDate');
                  }}
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(
                      formHeader.current.getFieldValue() &&
                        formHeader.current.getFieldValue()['EffectiveEndDate']
                        ? dayjs(formHeader.current.getFieldValue()['EffectiveEndDate'])
                          .add(1, 'day')
                          .format('YYYY-MM-DD')
                        : ''
                    ) ||
                    d.isBefore(dayjs().add(1, 'day').format('YYYY-MM-DD'))
                  }
                />
              </Form.Item>
              <Form.Item
                label={translation(props.translationCache, constant.effectiveEndDate)}
                name="EffectiveEndDate">
                <DatePicker
                  inputReadOnly={true}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  onChange={(value) => {
                    handleChange(value, 'EffectiveEndDate');
                  }}
                  disabledDate={(d) => {
                    const effectiveStartDate =
                      formHeader.current.getFieldValue('EffectiveStartDate');
                    return (
                      !d ||
                      (effectiveStartDate && d.isBefore(dayjs(effectiveStartDate))) ||
                      d.isBefore(dayjs().startOf('day'))
                    );
                  }}
                />
              </Form.Item>
              <Form.Item
                label={translation(props.translationCache, constant.frequency)}
                name="FrequencyId"
                rules={[{ required: true }]}>
                <Select
                  style={{ width: '100%' }}
                  placeholder={translation(props.translationCache, 'Select Frequency')}
                  onChange={(value) => handleChange(value, 'FrequencyId')}>
                  {frequencyList &&
                    Array.isArray(frequencyList) &&
                    frequencyList.map((freq, index) => {
                      return (
                        <Option key={index} value={freq.Value}>
                          {translation(props.translationCache, freq.Key)}{' '}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              {formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    defaultOpenValue={dayjs('00:00', 'HH:mm')}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}
              {formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}
              {formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}

              {!formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    defaultOpenValue={dayjs('00:00', 'HH:mm')}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}
              {!formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}
              {!formObject.Id &&
                formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.workOrderCreationTime)}
                  name="CreationTime"
                  rules={[{ required: true }]}>
                  <TimePicker
                    allowClear={false}
                    style={{ width: '100%' }}
                    format={'HH:mm'}
                    onChange={(value) => handleChange(value, 'CreationTime')}
                  />
                </Form.Item>
              ) : null}
              {formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                <Form.Item
                  label={translation(props.translationCache, constant.selectDay)}
                  name="Days"
                  rules={[{ required: true }]}>
                  <Select
                    style={{ width: '100%' }}
                    mode={'multiple'}
                    virtual={false}
                    showSearch
                    placeholder={translation(props.translationCache, 'Select Days')}
                    onChange={(value) => handleChange(value, 'Days')}>
                    <Option value="0">
                      {translation(props.translationCache, constant.sunday)}
                    </Option>
                    <Option value="1">
                      {translation(props.translationCache, constant.monday)}
                    </Option>
                    <Option value="2">
                      {translation(props.translationCache, constant.tuesday)}
                    </Option>
                    <Option value="3">
                      {translation(props.translationCache, constant.wednesday)}
                    </Option>
                    <Option value="4">
                      {translation(props.translationCache, constant.thursday)}
                    </Option>
                    <Option value="5">
                      {translation(props.translationCache, constant.friday)}
                    </Option>
                    <Option value="6">
                      {translation(props.translationCache, constant.saturday)}
                    </Option>
                  </Select>
                </Form.Item>
              ) : null}
              {formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                <></>
              ) : null}
              {formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                <></>
              ) : null}
              {formHeader &&
                frequencyObject &&
                formHeader.current &&
                formHeader.current !== null &&
                formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                <>
                  <Form.Item
                    
                    label={translation(props.translationCache, constant.selectDay)}
                    name="Days"
                    rules={[{ required: true }]}>
                    <Select
                      virtual={false}
                      style={{ width: '100%' }}
                      mode={'multiple'}
                      showSearch
                      placeholder={translation(props.translationCache, 'Select Days')}
                      onChange={(value) => handleChange(value, 'Days')}>
                      {days &&
                        days.map((item) => {
                          return (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </>
              ) : null}

              <Form.Item
                
                name="Id"
                rules={[{ required: false }]}></Form.Item>

              </StyledBox>
            </StyledBoxHeader>
          ) : null}
        </>

        <Form.Item name="Id"></Form.Item>
      </Form>
      <Modal
        open={visible}
        width={800}
        closable
        title={translation(props.translationCache, constant.selectEquipment)}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}>
        <TableSelect
          data={tableData}
          translationCache={props.translationCache}
          key="Location"
          columns={[
            {
              title: translation(props.translationCache, 'Equipment'),
              dataIndex: 'DisplayCode',
              key: 'DisplayCode',
              ...getColumnSearchProps('DisplayCode')
            },
            {
              title: translation(props.translationCache, 'Equipment Description'),
              dataIndex: 'Name',
              key: 'Name',
              ...getColumnSearchProps('Name')
            }
          ]}
          handleDropdownChange={(e) => tableDropdownChange(e, 'visible')}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile
  };
};

export default connect(mapStateToProps)(PMDetails);
